import { useState } from 'react'

import { TagEventsEnum } from 'common/enums/TagEventsEnum'
import BaseBridge from 'config/bridge/BaseBridge'
import { AnalyticsTicketDetailsRaffle } from 'pages/afterSales/AfterSalesDetails/AfterSalesDetails.tags'

import { Carousel } from '@interco/inter-ui/components/Carousel'

import * as S from './RafflesCarousel.styles'
import { ICarouselProps, IRaffle } from './RafflesCarousel.types'
import { RaffleCard } from './RaffleCard/RaffleCard'
import { RaffleBottomSheet } from './RaffleBottomSheet/RaffleBottomSheet'

export const RafflesCarousel = ({ luckyNumber, raffles }: ICarouselProps) => {
  const [showBottomSheet, setShowBottomSheet] = useState(false)
  const [raffleDetails, setRaffleDetails] = useState<IRaffle | null>(null)

  const handleCardDetails = (raffle: IRaffle) => {
    AnalyticsTicketDetailsRaffle(raffle.title, raffle.raffleId)
    setShowBottomSheet(true)
    setRaffleDetails(raffle)

    BaseBridge.requestAnalytics(TagEventsEnum.CAP_FRONT, {
      screen: 'raffles carousel',
      raffleDetails: JSON.stringify(raffle),
    })
  }

  const rafflesSlider = raffles.map((raffle) => (
    <RaffleCard key={raffle.raffleId} raffle={raffle} handleCardDetails={handleCardDetails} />
  ))

  return (
    <S.Container>
      <Carousel
        dots
        arrows={false}
        infinite={false}
        speed={500}
        slidesToShow={2}
        slidesToScroll={2}
        dotsType="medium"
        verticalMode={false}
        className="slider"
      >
        {rafflesSlider}
      </Carousel>

      <RaffleBottomSheet
        show={showBottomSheet}
        onClose={() => setShowBottomSheet(false)}
        luckyNumber={luckyNumber}
        raffleDetails={raffleDetails}
      />
    </S.Container>
  )
}
